import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserRoles: Getter<UserState, RootState> = (state) => {
  return state.current?.roles || []
}

export default getUserRoles
